import React from 'react';

const EditPen = ({ width = 24, height = 24, color = '#7F38E9', ...rest }) => {
  return (
    <svg {...rest} height={height} width={width} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.88144 20C4.75963 19.9998 4.6392 19.9742 4.52781 19.9249C4.41641 19.8756 4.31649 19.8037 4.23439 19.7137C4.15081 19.6245 4.08703 19.5186 4.04724 19.4029C4.00744 19.2873 3.99254 19.1646 4.00349 19.0428L4.21859 16.6769L14.1552 6.74108L17.2605 9.84636L7.32653 19.7813L4.96133 19.9965C4.93477 19.9989 4.90811 20.0001 4.88144 20ZM17.8804 9.22548L14.7759 6.1202L16.6381 4.25756C16.7196 4.17591 16.8164 4.11114 16.923 4.06694C17.0296 4.02275 17.1438 4 17.2592 4C17.3746 4 17.4888 4.02275 17.5954 4.06694C17.702 4.11114 17.7988 4.17591 17.8804 4.25756L19.7425 6.1202C19.8241 6.20176 19.8889 6.29862 19.9331 6.40523C19.9773 6.51184 20 6.62611 20 6.74152C20 6.85693 19.9773 6.9712 19.9331 7.07782C19.8889 7.18443 19.8241 7.28128 19.7425 7.36284L17.8804 9.22548Z"
        fill={color}
      />
    </svg>
  );
};

export default EditPen;
